import React, { Fragment } from 'react';


class EndProject extends React.Component {

  render() {
    const { closedAt } = this.props;

    return (
      <Fragment>
        <div className="login-background">
          <div className="manutencao-card shadow p-5 text-center">
          <div className="text-center mb-5">
            <img src={require('../../assets/img/logo-green.svg')} alt="notification" style={{ maxWidth: '18rem' }}/>
          </div>
          <div className="text-center  mb-3 ">
            <h3 className="mb-3" style={{ fontWeight: 100, color: '#777777'}}>Prezado(a) Candidato(a)</h3>
            <h3 className="mb-3" style={{ fontWeight: 100, color: '#777777'}}>O processo de Matrícula encerrou em:</h3>
            <h3 style={{ fontWeight: 700, color: '#777777' }}>{closedAt}</h3>
          </div>
        </div>
        </div>
      </Fragment>
    );
  }
}

export default EndProject;
